import { Link } from "react-router-dom";
import { siteConfig } from "../lib/siteConfig";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#030705] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src={siteConfig.logoUrl} alt={siteConfig.name} className="w-10 h-10 rounded-full object-cover ring-1 ring-[#D4AF37]/60" />
            <span className="font-display text-xl">{siteConfig.name}</span>
          </div>
          <p className="text-white/50">Free to play social casino fun. Real rewards through sweepstakes.</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-3">Play</h4>
          <ul className="space-y-2 text-white/60">
            <li><Link to="/games" className="hover:text-white">Slots</Link></li>
            <li><Link to="/leaderboard" className="hover:text-white">Leaderboard</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-3">Company</h4>
          <ul className="space-y-2 text-white/60">
            <li>About</li><li>Press</li><li>Careers</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-3">Legal</h4>
          <ul className="space-y-2 text-white/60">
            <li>Terms</li><li>Privacy</li><li>Responsible Play</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 border-t border-white/5 flex flex-col md:flex-row justify-between text-xs text-white/40 gap-2">
        <span>© 2026 {siteConfig.name}. 18+ only · Play responsibly.</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#D4AF37]">Operator console →</Link>
      </div>
    </footer>
  );
}
